import React from 'react';
import './IconButton.scss';

function IconButton({ onClick, icon: Icon, className, unreadCount, ariaLabel }: { onClick: () => void, icon: React.ComponentType<React.SVGProps<SVGSVGElement>>, className?: string; unreadCount?: number; ariaLabel: string }) {
    const hasUnread = typeof unreadCount === 'number' && unreadCount > 0;
    const accessibleName = hasUnread ? `${ariaLabel} (${unreadCount})` : ariaLabel;

    return (
        <button
            type="button"
            className={`icon-button ${className ?? ''}`}
            onClick={onClick}
            aria-label={accessibleName}
        >
            <Icon className="icon-button-svg" aria-hidden="true" focusable="false" />
            {hasUnread ? <div className="icon-button--unread" aria-hidden="true">{unreadCount > 9 ? '9+' : unreadCount}</div> : null}
        </button>
    );
}

export default IconButton;
